import { DateService } from "@/core/services/Date.service";
import { NumberFormatterService } from "@/core/services";
import { NumberFormatType } from "@/core/types";
import { DateAdapter } from "@/infrastructure/adapters/dayJs/DayJs.adapter";
import { NumberFormatterAdapter } from "@/infrastructure/adapters/number";

type PromoStatusChipColor = "success" | "secondary" | "warning" | "grey";
export type ConfidenceBarColor = "success" | "warning" | "error";

export const getPromoStatusChipColor = (statusKey: string): PromoStatusChipColor => {
  switch (statusKey) {
    case "ACTIVE":
    case "APPROVED":
      return "success";
    case "DRAFT":
      return "grey";
    case "COMPLETED":
      return "secondary";
    case "CANCELLED":
      return "warning";
    default:
      return "grey";
  }
};

export const getMatchBreakdownDotColor = (statusKey: string | null | undefined): string => {
  if (!statusKey) {
    return "var(--grey-400)";
  }
  const key = statusKey.toUpperCase();
  if (key.includes("CONFIRM") || key.includes("AUTO_MATCH") || key.includes("MATCHED")) {
    return "var(--success-500)";
  }
  if (key.includes("REVIEW") || key.includes("PENDING")) {
    return "var(--info-500)";
  }
  if (key.includes("OVERRIDE") || key.includes("LOW")) {
    return "var(--warning-500)";
  }
  if (key.includes("DISPUTE")) {
    return "var(--error-500)";
  }
  return "var(--grey-400)";
};

export const formatCreatedRelative = (createdAt: string | null | undefined): string => {
  if (!createdAt) {
    return "";
  }
  const dateService = new DateService(new DateAdapter());
  const today = dateService.getCurrentDate().toISOString();
  const days = Math.abs(dateService.diff(createdAt, today, "day"));
  if (days === 0) {
    return "today";
  }
  if (days === 1) {
    return "1 day ago";
  }
  return `${days} days ago`;
};

export const getEndDateClassName = (isPast: boolean, isNear: boolean): string => {
  if (isPast) {
    return "text-error-600";
  }
  if (isNear) {
    return "text-warning-600";
  }
  return "text-grey-700";
};

export const getPromotionSearchKeywords = (search: string | null | undefined): string[] => {
  const trimmed = search?.trim();
  return trimmed ? [trimmed] : [];
};

export const getConfidenceBarColor = (score: number): ConfidenceBarColor => {
  const rounded = Math.round(score);
  if (rounded >= 85) {
    return "success";
  }
  if (rounded >= 60) {
    return "warning";
  }
  return "error";
};

export const formatPromotionCurrency = (
  amount: number | null | undefined,
  format: NumberFormatType = "accounting"
): string => {
  if (amount === null || amount === undefined) {
    return "-";
  }
  return new NumberFormatterService(new NumberFormatterAdapter()).format(amount, format);
};

export const formatPromotionDate = (
  date: string | null | undefined,
  format: string = "MMM D, YYYY"
): string => {
  if (!date) {
    return "-";
  }
  return new DateService(new DateAdapter()).format(date, format);
};
